import React, { FC, SVGProps } from 'react'

export const IconCirclePlus24: FC<SVGProps<SVGSVGElement>> = props => (
  <svg fill="none" height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-7.333 6a7.333 7.333 0 1 1 14.666 0 7.333 7.333 0 0 1-14.666 0ZM12 8.665c.368 0 .667.298.667.667v2h2a.667.667 0 0 1 0 1.333h-2v2a.667.667 0 0 1-1.333 0v-2h-2a.667.667 0 0 1 0-1.334h2v-2c0-.368.298-.666.666-.666Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
